import { render, staticRenderFns } from "./CameraLayout.vue?vue&type=template&id=a48fd9f6&scoped=true&"
import script from "./CameraLayout.vue?vue&type=script&lang=js&"
export * from "./CameraLayout.vue?vue&type=script&lang=js&"
import style0 from "./CameraLayout.vue?vue&type=style&index=0&id=a48fd9f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48fd9f6",
  null
  
)

export default component.exports